export const FLAG_GETTING_INTERNAL_PARCELS = 'FLAG_GETTING_INTERNAL_PARCELS';
export const GET_INTERNAL_PARCELS = 'GET_INTERNAL_PARCELS';
export const CLEAR_INTERNAL_PARCELS = 'CLEAR_INTERNAL_PARCELS';
export const FLAG_INTERNAL_PARCEL_ACTIVITY = 'FLAG_INTERNAL_PARCEL_ACTIVITY';
export const GET_INTERNAL_PARCEL = 'GET_INTERNAL_PARCEL';
export const CLEAR_INTERNAL_PARCEL = 'CLEAR_INTERNAL_PARCEL';
